<template>
    <div v-if="currentStep < steps.length">
        <div class="cart-steps max-w-screen-sm mx-auto flex items-center justify-between lg:px-2 sm:text-2xl">
            <div
                v-for="(step, index) in steps"
                :key="`step-${++index}`"
                :class="{
                    'flex cart-steps__item': true,
                    active: index == currentStep,
                    finished: index < currentStep,
                }"
            >
                <div class="flex flex-col sm:flex-row items-center">
                    <span
                        class="cart-steps__point border border-grey rounded-full h-10 w-10 flex items-center justify-center high-contrast:border-yellow-300"
                        :class="{ 'bg-orange text-white high-contrast:bg-yellow-300 high-contrast:text-black': index == currentStep }"
                    >
                        {{ index }}
                    </span>
                    <span class="cart-steps__title px-2 text-center">
                        {{ __(step) }}
                    </span>
                </div>
                <div class="cart-steps__separator" v-if="index < steps.length">
                    <span></span>
                </div>
            </div>
        </div>
        <div
            class="mb-8 mt-16"
            v-for="(title, index) in titles"
            v-bind:key="`step-${++index}`"
        >
            <h1 v-if="index == currentStep">{{ __(title) }}</h1>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        currentStep: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            steps: ["Koszyk", "Dostawa i płatność", "Potwierdzenie"],
            titles: ["Koszyk", "Dostawa i płatność", "Sprawdź zamówienie"],
        };
    },
};
</script>
